module.exports = __webpack_public_path__ + "img/cover.42b7ee69.jpg";